<div class="password-reset-container">

  <h2 class="ui header center aligned light">Reset Password</h2>

  <div *ngIf="!isTokenValid; else tokenValid" class="invalid-token">


    <div class="ui icon negative message">
      <i class="exclamation circle icon"></i>

      <div class="content">
        <div class="header">
          Invalid Token
        </div>
        <p>
          Token provided is invalid. Please reset your password again <a [routerLink]="['/auth/password/forgot']">
            here</a>.
        </p>

      </div>


    </div>







  </div>





  <ng-template #tokenValid>

    <div *ngIf="isTokenValid && !passwordResetDone">

      <div class="ui form">

        <div class="field required">
          <label>New Password</label>
          <div class="ui left icon input">
            <i class="lock icon"></i>
            <input type="password" name="password" placeholder="Password" [(ngModel)]="newPassword" />
          </div>
        </div>

        <div class="field required">
          <label>Confirm Password</label>
          <div class="ui left icon input">
            <i class="lock icon"></i>
            <input type="password" name="password" placeholder="Confirm Password" [(ngModel)]="c_newPassword" />
          </div>
        </div>

        <button class="ui fluid large primary button reset-password" (click)="resetPassword()">Reset Password</button>

        <div class="ui error message"></div>

      </div>

    </div>

  </ng-template>


  <div *ngIf="passwordResetDone" class="password-reset-done">

    <div>
      Your password has been successfully updated.
    </div>

    <div class="link-to-login">
      <a [routerLink]="['/auth/login']">
        Go to Sign In Page
      </a>
    </div>
  </div>

</div>